import { type FailedProps } from "@hg/activity-utils"

import { ModalContent } from "@/components/Modal"
import { i18n } from "@/i18n"

import styles from "./index.module.scss"

export const Failed: React.FC<FailedProps> = (props) => {
    const { onClose, type } = props

    return (
        <ModalContent
            size="small"
            onCancel={onClose}
            showCancelBtn={false}
            showOkBtn={false}
        >
            <div className={styles.text}>
                {type === "default" && i18n.get("lottery.text_fail")}
                {type === "noReward" && i18n.get("lottery.text_noReward")}
            </div>
        </ModalContent>
    )
}
